import React from "react";
import { map } from "lodash";
import styled from "styled-components";
import {
  FontSize,
  FontWeight,
  GlossyThemeProvider,
  Spacing,
  ZIndexes,
  background,
  content,
  prettyScrollbars,
} from "@glossy";
import Card from "@radarly/components/panels/card-library/model-card";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";

interface Template {
  id: string;
  url: string;
  title: string;
  description: string;
  comingSoon?: boolean;
}

interface IProps {
  templates: Template[];
  title: string;
  emptyTemplate: Template;
  onClick?: () => void;
}

const Root = styled.div`
  z-index: ${ZIndexes.Content};
  width: 100%;
  height: 100%;
  background-color: ${background};
  padding: ${Spacing.Jumbo};
  ${prettyScrollbars()};
`;

const Title = styled.h1`
  color: ${content};
  font-size: ${FontSize.Large};
  font-weight: ${FontWeight.Bold};
  margin-top: ${Spacing.Large};
  margin-bottom: ${Spacing.Medium};
`;

const Viz = styled.div`
  display: flex;
  column-gap: ${Spacing.Large};
  row-gap: ${Spacing.Large};
  flex-wrap: wrap;
  > * {
    flex: 0 0 auto;
  }
`;

const PanelsTemplateLibraryLayout = ({
  templates,
  title,
  emptyTemplate,
  onClick,
}: IProps) => {
  const locale = useCurrentUserLocale();
  return (
    <GlossyThemeProvider name="edition">
      <Root>
        <Card
          viz=""
          title={emptyTemplate.title}
          description={emptyTemplate.description}
          url={emptyTemplate.url}
          onClick={onClick}
        />
        <Title>{title}</Title>
        <Viz>
          {map(templates, ({ url, id, title, description, comingSoon }) => (
            <Card
              key={id}
              viz={id}
              title={title}
              description={description}
              url={url}
              onClick={onClick}
              active={!comingSoon}
              locale={locale}
            />
          ))}
        </Viz>
      </Root>
    </GlossyThemeProvider>
  );
};

export default PanelsTemplateLibraryLayout;
